export type OfferBillingDiscount = {
  amountOff: null | number;
  percentOff: null | number;
};

export type OfferBillingContext = {
  companyName: string;
  currency: string;
  // Resolved from the offer's pre-applied promo code. The code itself is never sent to the client —
  // only the resulting discount shape. Null when the offer has no code or it no longer validates.
  discount: null | OfferBillingDiscount;
  isMonthlyEnabled: boolean;
  monthlyPriceInCents: null | number;
  planType: string;
  // The offer carries a promo code that Stripe no longer accepts — payment must stay blocked until
  // an admin replaces or removes it.
  promoInvalid: boolean;
  slug: string;
  yearlyPriceInCents: number;
};

export type BillingSubscribeResponse = {
  alreadySubscribed?: boolean;
  clientSecret: null | string;
  hostedInvoiceUrl: null | string;
  offer?: OfferBillingContext;
};

// Thrown by the pay-time price guard when the checkout session's server-side amount differs from
// what the page displayed (the admin edited the offer mid-session). The payment is aborted and the
// offer context refetched; billing-form treats it as an already-handled abort (no generic toast).
export class OfferPriceChangedError extends Error {
  constructor() {
    super('Offer pricing changed since the page was loaded');
    this.name = 'OfferPriceChangedError';
  }
}

export type FinalizeVerificationResponse = {
  subscriptionPaid: boolean;
};

export type FinalizeVerificationRequest = {
  companyId?: string;
  // Promo-code path: verify the card and set the default payment method, but leave the current
  // subscription unpaid so the coupon step can recreate a discounted subscription without a double
  // charge. Omitted/false for the normal path, which pays the subscription during verification.
  deferSubscriptionPayment?: boolean;
  paymentIntentId: string;
  stripeSubscriptionId?: string;
};
